export type RoundReached = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const ROUND_LABELS: Record<RoundReached, string> = {
  0: "Group Exit",
  1: "R32",
  2: "R16",
  3: "QF",
  4: "SF",
  5: "Final",
  6: "Winners",
};

export interface Team {
  id: string;          // ISO alpha-3 lowercased
  name: string;
  flag_code: string;   // ISO alpha-2 lowercased
  pot: 1 | 2 | 3;
  wins: number;
  draws: number;
  goals_for: number;
  goals_against: number;
  clean_sheets: number;
  yellows: number;
  reds: number;
  round_reached: RoundReached;
  eliminated: number;  // 0 | 1 — knocked out of the tournament
}

export type PaidStatus = "false" | "cash" | "transfer";

export interface Entry {
  id: number;
  name: string;
  pot1_team: string;
  pot2_team: string;
  pot3_team: string;
  created_at: number;  // unix ms
  paid: PaidStatus;
  comp_id: 1 | 2;
}

export interface EntryWithScores {
  id: number;
  name: string;
  pot1: Team;
  pot2: Team;
  pot3: Team;
  mainPoints: number;
  cardsTotal: number;   // weighted: yellows + reds * 2 (drives sort/tiebreaks)
  yellows: number;
  reds: number;
  goalsConceded: number;
}

export interface ConcededLeader {
  name: string;        // entry name
  teams: { name: string; flag_code: string; goals_against: number }[];
}

export interface PrizeTier {
  score: number;
  names: string[];
}

export interface SidePrize {
  leaders: string[];   // entry names
  score: number;
  // The 2nd and 3rd placed score tiers behind the leader (each may be a tie).
  runnersUp?: PrizeTier[];
  // Card breakdown for the Dirty Bastards prize, set only when every
  // co-leader shares the same yellow/red split (otherwise left undefined).
  yellows?: number;
  reds?: number;
  // Per-leader goals-conceded breakdown for the Sieves prize.
  concededBreakdown?: ConcededLeader[];
}

export interface LeaderboardsResponse {
  meta: {
    entryCount: number;
    daysUntilKickoff: number | null;
  };
  entries: EntryWithScores[];
  sidePrizes: {
    dirtyBastards: SidePrize;
    sieves: SidePrize;
    whippingBoys: SidePrize;
  };
}

export interface DrawSuccess {
  combo: { pot1: string; pot2: string; pot3: string };
}

export interface DrawExhausted {
  error: "exhausted";
}

export type DrawResponse = DrawSuccess | DrawExhausted;

export interface EntryCreateRequest {
  name: string;
  pot1: string;
  pot2: string;
  pot3: string;
}

export interface EntryCreateSuccess extends Entry {}

export interface ApiError {
  error: string;
  message?: string;
  offendingIds?: string[];
}

export interface TeamUpdate {
  id: string;
  wins: number;
  draws: number;
  goals_for: number;
  goals_against: number;
  clean_sheets: number;
  yellows: number;
  reds: number;
  round_reached: number;
  eliminated: number;
}

export interface AdminTeamsResponse {
  teams: Team[];
}

export interface AdminTeamsUpdateRequest {
  updates: TeamUpdate[];
}

export interface AdminTeamsUpdateSuccess {
  updated: number;
}
